import { Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RxHelper } from '../../core/utils/rxjxHelper';
import { SelectionModel } from '@angular/cdk/collections';
import { OrganizationStore } from '../../core/store';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
    selector: 'app-organizations-select',
    standalone: true,
    imports: [CommonModule, RadioButtonModule, FormsModule],
    templateUrl: './organizations-select.component.html',
    styleUrls: ['./organizations-select.component.scss'],
    providers: [
        RxHelper,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => OrganizationsSelectComponent),
            multi: true,
        },
    ],
})
export class OrganizationsSelectComponent implements OnInit, ControlValueAccessor {
    @Input() showNone = true;
    @Input() isDisabled = false;

    private readonly _rxHelper = inject(RxHelper);
    private readonly _store = inject(OrganizationStore);

    protected readonly organizations$ = this._store.organizations$;
    protected readonly selectionModel = new SelectionModel<string | null>(false);
    protected onChangeFn?: (value: string | null) => unknown;
    protected onTouchedFn?: () => unknown;

    ngOnInit() {
        this.selectionModel.changed.pipe(this._rxHelper.autoUnsubscribe).subscribe(() => {
            this.onChangeFn?.(this.selectionModel.selected[0]);
        });
        this.selectionModel.select(null);
    }

    writeValue(obj: unknown): void {
        if (typeof obj === 'string') {
            this.selectionModel.select(obj);
        } else {
            this.selectionModel.select(null);
        }
    }

    registerOnChange(fn: any): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedFn = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }
}
